<template>
  <div class="pricing-switcher">
    <div class="fieldset" data-qa="shippingToggle">
      <input
        type="radio"
        name="group-a"
        value="shippable"
        id="shippable"
        v-model="shippable"
      />
      <label for="shippable">{{ $t('wantNo') }}</label>
      <input
        type="radio"
        name="group-a"
        value="non-shippable"
        id="non-shippable"
        v-model="shippable"
      />
      <label for="non-shippable">{{ $t('wantYes') }}</label>
      <span class="switch"></span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      shippable: 'shippable'
    }
  },
  watch: {
    shippable: function() {
      if (this.shippable === 'shippable') this.$emit('delivery-changed', true)
      else this.$emit('delivery-changed', false)
    }
  }
}
</script>

<style lang="scss" scoped>
//----------------
$color-1: var(--primaryDark);
$color-2: var(--bright);
$color-3: var(--bg);
$color-4: var(--bg-superLight);
//----------------
body {
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  color: color-3;
}
//----------------
.pricing-switcher {
  $bg-padding: 5px;
  $button-width: 110px;
  $button-height: 40px;
  $animation-time: 0.3s;
  text-align: center;

  .fieldset {
    display: inline-block;
    position: relative;
    margin-top: 1.3em;
    padding: $bg-padding;
    border-radius: 50em;
    box-shadow: 0px 1px 5px var(--bg-superLight);
  }

  input[type='radio'] {
    position: absolute;
    opacity: 0;
  }

  label {
    position: relative;
    margin: 0;
    z-index: 1;
    display: inline-block;
    float: left;
    width: $button-width;
    height: $button-height;
    line-height: $button-height;
    cursor: pointer;
    color: $color-3;
    text-transform: uppercase;
    text-decoration: none;
    font-weight: bold;
    transition-delay: 0.1s;
    transition: color $animation-time ease;
  }

  input[type='radio']:checked + label {
    color: $color-2;
    text-decoration: none;
  }

  .switch {
    /* floating background */
    position: absolute;
    top: $bg-padding;
    left: $bg-padding;
    height: $button-height;
    width: $button-width;
    background-color: $color-1;
    border-radius: 50em;
    transition: transform $animation-time;
  }

  input[type='radio']:checked + label + .switch,
  input[type='radio']:checked + label:nth-of-type(n) + .switch {
    /* use label:nth-of-type(n) to fix a bug on safari with multiple adjacent-sibling selectors*/
    -webkit-transform: translateX($button-width);
    -moz-transform: translateX($button-width);
    -ms-transform: translateX($button-width);
    -o-transform: translateX($button-width);
    transform: translateX($button-width);
  }
}

// @media screen and (max-width: 500px){
//   .pricing-switcher {
//     $bg-padding: 1px;
//     $button-width: 115px;
//     label {
//       width: $button-width;
//     }
//     .switch {
//       width: 110px;
//     }
//   }
// }
// @media screen and (max-width: 340px){
//   .pricing-switcher {
//     $bg-padding: 1px;
//     $button-width: 85px;
//     label {
//       width: $button-width;
//     }
//     .switch {
//       width: 60px;
//     }
//   }
// }
</style>
